import { Skeleton, styled } from "@mui/material";

const DarkSkeleton = styled(Skeleton)(({theme}) => ({
    backgroundColor: theme.palette.mode !== 'dark' && theme.palette.primary.darker
}));

export default DarkSkeleton;